var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M31,16A15,15,0,1,0,16,31,15,15,0,0,0,31,16ZM3,16A13,13,0,1,1,16,29,13,13,0,0,1,3,16Z",
    transform: "translate(-1 -1)",
    fill: "#35c290"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M19.872,21.59,14.292,16l5.58-5.59a1,1,0,0,0,0-1.41h0a1,1,0,0,0-1.41,0L12.1,15.36a.91.91,0,0,0,0,1.28L18.462,23a1,1,0,0,0,1.41,0h0A1,1,0,0,0,19.872,21.59Z",
    transform: "translate(-1.002 -1)",
    fill: "#35c290"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapleft);
export default __webpack_public_path__ + "static/media/swapleft.cba11cd1e3ab25e5fbce2277082da630.svg";
export { ForwardRef as ReactComponent };